import React from "react";
import { RaisedButton, TextField } from "material-ui";

import {
  injectStripe,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from "react-stripe-elements";

class PaymentMethodEntrySundance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false
    };

    this.onFieldChange = this.onFieldChange.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  getStyles() {
    return {
      form: {
        maxWidth: 400,
        margin: 0
      },
      actions: {
        marginTop: "1em"
      },
      error: {
        color: "#FF4136",
        margin: "-0.5em 0 0.5em"
      },
      elementContainer: {
        display: "block",
        margin: "10px 0 20px 0",
        padding: "10px 14px",
        boxShadow:
          "rgba(50, 50, 93, 0.15) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 0px, rgba(0, 0, 0, 0.04) 0px -1px 0px",
        borderRadius: 4,
        background: "white"
      },
      cardElement: {
        base: {
          fontSize: 16,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, Menlo, monospace",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#FF4136" //'#9e2146',
        }
      }
    };
  }

  onFieldChange(key, e) {
    let { value } = e.target;
    this.setState({
      [key]: value
    });
  }

  render() {
    var styles = this.getStyles();

    return (
      <form style={styles.form}>
        <div style={styles.elementContainer}>
          <CardElement
            style={styles.cardElement}
            onReady={el => el.focus()}
            onChange={function() { this.props.onUpdate(this.props.stripe); }.bind(this)}
          />
        </div>
        <div style={styles.actions}>
          {this.props.paymentInfoUpdateErrorMessage ? (
            <div style={styles.error}>
              {this.props.paymentInfoUpdateErrorMessage}
            </div>
          ) : null}        
        </div>
      </form>
    );
  }
}

export default injectStripe(PaymentMethodEntrySundance);



// WEBPACK FOOTER //
// ./src/app/components/partials/payment-method-entry-sundance.jsx